import Vue from 'vue';

Vue.filter('money', (value: string) => {
	return '$' + parseFloat(value).toFixed(2);
});
